export const ALLOWED_KEYS = {
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
  ENTER: 'Enter',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  MINUS_SIGN: '-',
  DECIMAL: '.',
  COMMA: ',',
  MULTIPLY: '*',
  DIVIDE: '/',
  PLUS: '+',
  OPEN_PAREN: '(',
  CLOSE_PAREN: ')',
  TAB: 'Tab',
  SHIFT: 'Shift',
  CONTROL: 'Control',
  ALT: 'Alt',
  ESCAPE: 'Escape',
  HOME: 'Home',
  END: 'End',
  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',
};

export const allowedKeysSet = new Set(Object.values(ALLOWED_KEYS));

export const STEP_DIRECTIONS = {
  UP: 'up',
  DOWN: 'down',
} as const;

export const STEP_DIRECTION_LABEL = {
  [STEP_DIRECTIONS.UP]: 'Increase',
  [STEP_DIRECTIONS.DOWN]: 'Decrease',
} as const;

export const BUTTON_POSITIONS = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEADING: 'leading',
  TRAILING: 'trailing',
} as const;

export const NUMBER_INPUT_VARIANTS = {
  DEFAULT: 'default',
  STEPPER: 'stepper',
} as const;

export const CHANGE_META_TYPE = {
  CHANGE_START: 'changeStart',
  CHANGE: 'change',
  CHANGE_END: 'changeEnd',
  CHANGE_CANCEL: 'changeCancel',
} as const;

export const SCRUB_DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export const SCRUB_TO_STEP_MAP = {
  [SCRUB_DIRECTION.LEFT]: STEP_DIRECTIONS.DOWN,
  [SCRUB_DIRECTION.RIGHT]: STEP_DIRECTIONS.UP,
} as const;
